import { takeLatest, put } from 'redux-saga/effects';
import { message } from 'antd';

import { getLogData } from '@api/errorConfig';
import { autoRequest } from '@api/createRequestStore';

import * as actions from './actions';
import * as types from './types';

function* fetching() {
  try {
    yield put(actions.fetching());
    yield autoRequest(getLogData, types.SCOPE);
  } catch (error) {
    message.error(error.message || 'Unknown error!');
  }
}

function* initRequest() {
  yield put(actions.init());
}

function* watchInitRequest() {
  yield takeLatest([
    types.INIT,
  ], initRequest);
}

function* watchFetching() {
  yield takeLatest([
    types.FETCH_DATA,
  ], fetching);
}

export default [
  watchInitRequest,
  watchFetching
];
